import UserAccessGroupsAlert from './UserAccessGroupsAlert';

export default UserAccessGroupsAlert;
